'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module parseHostname
 *
 * @desc Extracts the projectDomain of the location, and provides the default
 * publicationName if none is supplied.
 */

/**
 * @typedef {Object} Hostname
 * @property {string} projectDomain Full host name, like
 * "interaktiv.tagesanzeiger.ch".
 * @property {string} publicationDomain Last two parts of the project
 * domain, like "tagesanzeiger.ch".
 * @property {string} publicationName Just the media name, like "tagesanzeiger".
 */

/**
 * @param host {string} A window.location.projectDomain, in case it differs
 * from the current location.
 *
 * @returns {Hostname}
 */
function parseHostname() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;

  // get the full host name.
  var projectDomain = host;

  /** Create an array with the projectDomain parts */
  var hostnameArray = projectDomain.split('.');

  /**
   * Domain without any sub domains = last two parts of the projectDomain
   */
  var publicationDomain = hostnameArray.slice(-2).join('.');

  /**
   * Media Name: Domain without top level domain.
   */
  var publicationName = hostnameArray[hostnameArray.length - 2];

  return {
    projectDomain: projectDomain,
    publicationDomain: publicationDomain,
    publicationName: publicationName
  };
}

exports.default = parseHostname;


//////////////////
// WEBPACK FOOTER
// ./~/ta-js-toolbox/dist/parseHostname.js
// module id = 128
// module chunks = 0